export default __webpack_public_path__ + "static/logo-9a2c1f74cbbbb67680d9b245c77ae1ba.svg";